import React from 'react';
import VendorProductTable from './vendorproductSingleView/VendorProductTable';

export default function VendorProduct() {
	return (
		<div>
			<VendorProductTable />{' '}
		</div>
	);
}
